import type { IErrors } from './types';

export function installGlobalErrorHandlers(errors: IErrors): () => void {
  const onError = (event: ErrorEvent) => {
    errors.capture(event.error ?? event.message, {
      tags: { source: 'window.onerror' },
      extra: {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      },
    });
  };

  const onRejection = (event: PromiseRejectionEvent) => {
    errors.capture(event.reason, {
      tags: { source: 'unhandledrejection' },
    });
  };

  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);

  return () => {
    window.removeEventListener('error', onError);
    window.removeEventListener('unhandledrejection', onRejection);
  };
}
